import { useStore } from '../lib/store.js';

const IconPin = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <line x1="12" y1="17" x2="12" y2="22"/>
    <path d="M5 17h14v-1.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V6h1a2 2 0 0 0 0-4H8a2 2 0 0 0 0 4h1v4.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24Z"/>
  </svg>
);

const IconPonder = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <circle cx="11" cy="11" r="8"/>
    <line x1="21" y1="21" x2="16.65" y2="16.65"/>
  </svg>
);

const IconBranch = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <line x1="6" y1="3" x2="6" y2="15"/>
    <circle cx="18" cy="6" r="3"/>
    <circle cx="6" cy="18" r="3"/>
    <path d="M18 9a9 9 0 0 1-9 9"/>
  </svg>
);

const IconForward = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <polyline points="15 17 20 12 15 7"/>
    <path d="M4 18v-2a4 4 0 0 1 4-4h12"/>
  </svg>
);

export function V2MessageActions({ ev, threadURN, channelID, currentBranchId, onBranch, onForward }) {
  const togglePin = useStore(s => s.togglePin);
  const togglePonder = useStore(s => s.togglePonder);
  const msgID = ev?.event_id || ev?.body?.client_msg_id || '';
  const pinned = useStore(s => s.annotationsByThread[threadURN]?.pinned?.has(msgID) ?? false);
  const pondered = useStore(s => s.annotationsByThread[threadURN]?.pondered?.has(msgID) ?? false);

  if (!msgID || !threadURN) return null;

  return (
    <div className="v2-msg-actions" data-testid="v2-msg-actions">
      <button type="button" className={`v2-act-btn ${pinned ? 'v2-act-active' : ''}`}
        aria-label="Pin message" title="Pin"
        data-testid="v2-act-pin"
        onClick={() => togglePin({ threadURN, msgID })}>
        <IconPin />
      </button>
      <button type="button" className={`v2-act-btn ${pondered ? 'v2-act-active' : ''}`}
        aria-label="Ponder message" title="Ponder"
        data-testid="v2-act-ponder"
        onClick={() => togglePonder({ threadURN, msgID })}>
        <IconPonder />
      </button>
      <button type="button" className="v2-act-btn"
        aria-label="Branch from this message" title="Branch"
        data-testid="v2-act-branch"
        onClick={onBranch}>
        <IconBranch />
      </button>
      <button type="button" className="v2-act-btn"
        aria-label="Forward this message" title="Forward"
        data-testid="v2-act-forward"
        onClick={onForward}>
        <IconForward />
      </button>
    </div>
  );
}
